import React, { Fragment } from 'react';
import { ArrowDownIcon } from 'lucide-react';
const steps = [{
  bg: 'bg-red-50',
  border: 'border-red-200',
  textCol: 'text-red-900',
  emoji: '🔴',
  title: 'LO QUE HACE EL ÓVULO',
  text: 'Elimina el 70% del hongo visible en la superficie'
}, {
  bg: 'bg-orange-50',
  border: 'border-orange-200',
  textCol: 'text-orange-900',
  emoji: '⚠️',
  title: 'LO QUE EL ÓVULO NO PUEDE HACER',
  text: 'Penetrar el BIOFILM: la capa protectora que el hongo construye en menos de 90 minutos'
}, {
  bg: 'bg-rose-900',
  border: 'border-rose-950',
  textCol: 'text-white',
  emoji: '🔄',
  title: 'EL RESULTADO',
  text: 'El 30% que sobrevivió dentro del Biofilm se multiplica y vuelve en 7 a 21 días'
}];
export function MechanismSection() {
  return <section className="w-full bg-[#F8F5FC] px-6 py-16" data-id="element-148">
      <div className="max-w-2xl mx-auto" data-id="element-149">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-150">
          POR QUÉ NADA FUNCIONÓ HASTA AHORA
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-12" data-id="element-151">
          El problema no es la Cándida. Es su capa protectora, el Biofilm.
        </p>

        <div className="flex flex-col items-center gap-0 mb-10 max-w-md mx-auto" data-id="element-152">
          {steps.map((step, i) => <Fragment key={i} data-id="element-153">
              <div className={`w-full ${step.bg} rounded-[16px] p-6 border ${step.border} shadow-[0_4px_24px_rgba(0,0,0,0.08)] text-center`} data-id="element-154">
                <p className={`text-[14px] font-bold ${step.textCol} mb-2 uppercase tracking-wide`} data-id="element-155">
                  {step.emoji} {step.title}
                </p>
                <p className={`text-[16px] ${step.textCol} leading-relaxed font-medium`} data-id="element-156">
                  {step.text}
                </p>
              </div>
              {i < steps.length - 1 && <div className="py-3 text-brand-muted" data-id="element-157">↓</div>}
            </Fragment>)}
        </div>

        <div className="bg-brand-violet/5 border-l-4 border-brand-violet rounded-r-[16px] p-6 mb-8 max-w-xl mx-auto" data-id="element-158">
          <p className="text-[16px] text-brand-text leading-relaxed font-medium" data-id="element-159">
            💡 Mientras no se disuelva el Biofilm primero, cualquier tratamiento
            que uses va a ser parcialmente inútil.
          </p>
        </div>

        <p className="text-[16px] text-brand-text leading-relaxed text-center font-bold max-w-xl mx-auto" data-id="element-160">
          El Método pH-ZERO es el único protocolo adaptado a Argentina que ataca
          el Biofilm, el intestino y la alimentación al mismo tiempo. En 21
          días.
        </p>
      </div>
    </section>;
}